import { useState, useCallback } from 'react';
import { logEvent, analytics } from '../firebase.js';
import { isNativeApp } from '../services/platform-service.js';
import { storeUrlForDevice } from '../services/app-links.js';

// "공유 링크로 들어온 사람은 보는 건 웹에서, **하는 건** 앱에서."
//
// 디자인·프로필을 **보는 것**은 그대로 웹에서 되게 둔다 — 링크를 받고 들어온
// 사람에게 첫 화면부터 설치를 요구하면 대부분 그냥 떠난다. 대신 그 다음
// 행동(이 스타일로 만들기 등)에서 앱으로 보낸다. 그 지점에는 이미 "해보고
// 싶다" 가 생겨 있어서 설치 이유가 분명하다.
//
// 데스크톱은 게이트하지 않는다 — 스토어로 보내도 설치할 기기가 아니다.
// 네이티브 앱 안에서도 당연히 게이트하지 않는다.
export function useAppGate(surface) {
  const [open, setOpen] = useState(false);
  const storeUrl = storeUrlForDevice();
  const shouldGate = !isNativeApp() && !!storeUrl;

  // 게이트가 걸리면 true 를 돌려준다 — 호출부는 그때 원래 동작을 건너뛴다.
  const gate = useCallback((action) => {
    if (!shouldGate) return false;
    logEvent(analytics, 'app_gate_shown', { surface, action });
    setOpen(true);
    return true;
  }, [shouldGate, surface]);

  return { gate, open, close: () => setOpen(false), storeUrl, surface };
}
